import React, { useState, useEffect } from "react";
import { ProcedureInput } from "./Utils/addProcedureInput";
import { Button } from "@mui/material";
import {
  useAddProcedureTemplatesMutation,
  useGetAllBranchesQuery,
  useUpdateProcedureMutation,
} from "../../../../Service/Masters";
import useSnackbar from "../../../../hooks/digitalMarketing/useSnackbar";
import Toast from "../../../../Component/DigitalMarketing/Toast";
import { useSelector } from "react-redux";
import BackdropLoader from "../../../../Component/DigitalMarketing/BackDropLoader";

const AddProcedure = (props) => {
  const { refetch, updateData, view, setShow } = props;
  const [addProcedure, { isLoading: addLoading }] =
    useAddProcedureTemplatesMutation();
  const [updateProcedure, { isLoading: updateLoading }] =
    useUpdateProcedureMutation();
  const { open, message, openSnackBar, type } = useSnackbar();
  const account = useSelector((state: any) => state.auth);
  const {roleName} = account
  const [formData, setFormData] = useState({
    procedureTitle: updateData.procedureTitle || "",
    price: updateData.price || "",
    cgst: updateData.cgst || "",
    sgst: updateData.sgst || "",
    notes: updateData.notes || "",
    instruction: updateData.instruction || "",
    branchId: updateData.branchId || "", // Set branchId if available for editing
  });

  const [submit, setSubmit] = useState(false);
  const { data: branchData } = useGetAllBranchesQuery<any>({
    refetchOnMountOrArgChange: true,
  });

  const handleChangeInfo = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async () => {
    setSubmit(true);
    const requiredFields = ["procedureTitle", "price", "cgst","sgst"];
    const isBranchUser = roleName === "branch";
    
    if (!isBranchUser) {
      requiredFields.push("branchId");
    }
    
    const missingFields = Object.entries(formData).filter(
      ([key, value]) => requiredFields.includes(key) && !value
    );
    
    if (missingFields.length > 0) {
      openSnackBar("Fill required data", "error");
      return;
    }
    

    try {
      if (updateData?.id) {
        await updateProcedure({
          id: updateData.id,
          ...formData,
        }).unwrap();
        openSnackBar("Updated successfully");
      } else {
        await addProcedure({
          ...formData,
          activeStatus: "1",
        }).unwrap();
        openSnackBar("Created successfully");
      }

      refetch();
      setTimeout(() => {
        setShow(false);
      }, 350);
    } catch (error: any) {
      console.log(error,"error")
      const errorMessage = error?.data?.error || "An error occurred";
      openSnackBar(errorMessage, "error");
    }
  };

  return (
    <div>
      <BackdropLoader loader={addLoading || updateLoading}/>
      <Toast open={open} type={type} message={message} />
      {!view && (
        <div className="mt-3">
          <span className="f-18 fw-700">
            {updateData.id ? "Edit Procedure" : "Add Procedure"}
          </span>
        </div>
      )}
      <div className="mt-3">
        <span className="f-18 fw-500 mt-3">Procedure Details</span>
      </div>
      {ProcedureInput.map((a, i) => (
        <div className="input-custom mt-2" key={i}>
          <a.tag
            img={a.img}
            label={a.label}
            name={a.name}
            value={formData[a.key]}
            handleChange={handleChangeInfo}
            validation={a.validation}
            keyName={a.key}
            submit={submit}
            disabled={view}
          />
        </div>
      ))}
      {roleName !== "branch" && (
        <div className="d-flex justify-content-between">
          <div>
            <span className="det-label">Branch</span>
          </div>
          <div>
            <select
              onChange={(event) => handleChangeInfo(event)}
              className="input-custom"
              placeholder="Select Branch"
              name="branchId"
              value={formData.branchId}
              disabled={view}
            >
              <option value="">Select Branch</option>
              {branchData?.data?.map((branch) => (
                <option key={branch.id} value={branch.id}>
                  {branch.branchName}
                </option>
              ))}
            </select>
          </div>
        </div>
      )}
      {!view && (
        <div
          className="d-flex justify-content-center mt-4 mb-3"
          onClick={handleSubmit}
        >
          <Button variant="contained" id="btn-save">
            {updateData?.id ? "Update Procedure" : "Add Procedure"}
          </Button>
        </div>
      )}
    </div>
  );
};

export default AddProcedure;
